import { render, staticRenderFns } from "./MerchantMain.vue?vue&type=template&id=a72c8cde"
import script from "./MerchantMain.vue?vue&type=script&lang=js"
export * from "./MerchantMain.vue?vue&type=script&lang=js"
import style0 from "./MerchantMain.vue?vue&type=style&index=0&id=a72c8cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports